angular.module('Const').constant('trackingStatusesConst', {
    'trackingStatuses': {
        'documentationprepared': 'Documentation Prepared',
        'bookingarranged': 'Booking Arranged',
        'collected': 'Collected',
        'intransit': 'In Transit',
        'arrivedatdestination': 'Arrived at Destination',
        'outfordelivery': 'Out for Delivery',
        'delivered': 'Delivered',
        'instore': 'In Store'
    }
});



// WEBPACK FOOTER //
// ./js/consts/trackingStatuses.js